import { SITE } from "@/lib/site-data";
import { ContactButtons } from "@/components/ContactButtons";

export function CTABand({ heading = "Ready to reserve your chauffeur?", sub = "Instant online quote, or speak with a live dispatcher during staffed hours." }: { heading?: string; sub?: string }) {
  return (
    <section className="border-y border-border bg-surface-2">
      <div className="container-x py-16 grid gap-8 lg:grid-cols-[1.4fr_1fr] items-center">
        <div>
          <p className="eyebrow mb-3">Book Your Ride</p>
          <h2 className="text-3xl md:text-4xl mb-3">{heading}</h2>
          <p className="text-muted-foreground max-w-xl">{sub}</p>
        </div>
        <div className="flex flex-col gap-3">
          <ContactButtons layout="stack" context="booking your chauffeur" />
          <a href={SITE.corporateUrl} target="_blank" rel="noopener noreferrer" className="btn-outline hover:bg-gold hover:text-primary-foreground">Open a Corporate Account</a>
        </div>

      </div>
    </section>
  );
}
